import script from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StarsComponent.vue?vue&type=style&index=0&id=51e5ce51&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e5ce51"]])

export default __exports__